import { useEffect, useState } from 'react'
import { useFileUpload } from 'hooks/use-file-upload/useFileUpload'
import { BackendContent, Content } from 'common/types/content.types'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useContentApi } from 'hooks/use-content-api/useContentApi'
import { useNotification } from 'hooks/use-notification/useNotification'
import { useHistory, useLocation } from 'react-router-dom'

export const useCreatePost = (createPostPage?: boolean) => {
  const maxTitleLength = 60
  const maxDescriptionLength = 1200
  const maxVideoFileSize = 25
  const maxImageFileSize = 2
  const { createContent, editContent, editSharedPost } = useContentApi()
  const theme = useTheme()
  const { notify } = useNotification()
  const { backendUser, backendPartner, backendUserFunctions } = useAuth()
  const { isDevice } = useScreenSizes()
  const { getProcessedFile } = useFileUpload()
  const { logEventAnalytics } = useAnalytics()
  const location = useLocation()
  const history = useHistory()
  const [cursorEl, setCursorEl] = useState<string>('')
  const [postDescription, setPostDescription] = useState<string>('')
  const [postTitle, setPostTitle] = useState<string>('')
  const [postId, setPostId] = useState<string>('')
  const [cursorPos, setCursorPos] = useState<number>(0)
  const [imageUploaded, setImageUploaded] = useState<boolean>(false)
  const [videoUploaded, setVideoUploaded] = useState<boolean>(false)
  const [newUploads, setNewUploads] = useState<boolean>(false)
  const [postEdited, setPostEdited] = useState<boolean>(false)
  const [edit, setShowEdit] = useState<boolean>(false)
  const [showReadOnly, setReadOnly] = useState<boolean>(true)
  const [posts, setPosts] = useState<Content[]>([])
  const [myPosts, setMyPosts] = useState<Content[]>([])
  const [postToEdit, setPostToEdit] = useState<Content>(null)
  const [showMediaError, setShowMediaError] = useState(null)
  const [getState, setState] = useState(null)
  const [previewImage, setPreviewImage] = useState([])
  const [postImages, setPostImages] = useState([])
  const [previewVideo, setPreviewVideo] = useState([])
  const [postVideo, setPostVideo] = useState([])
  const media = []
  const previewMedia = []
  const post: BackendContent[] = []
  const mediaCategory = []

  const getPostDetails = content => {
    try {
      return JSON.parse(content)?.body
    } catch (e) {
      return content
    }
  }

  const isImage = media => {
    return (
      media?.length > 0 &&
      ['jpeg', 'jpg', 'png']?.includes(media[0]?.split('.')[media[0]?.split('.').length - 1]?.toLowerCase())
    )
  }
  const isVideo = media => {
    return (
      media?.length > 0 &&
      ['mov', 'mp4']?.includes(media[0]?.split('.')[media[0]?.split('.').length - 1]?.toLowerCase())
    )
  }

  const picturesChanged = (initialPictures, currentPictures) => {
    if (Array.isArray(initialPictures)) {
      return initialPictures?.every(picture => currentPictures?.includes(picture))
    }
  }

  const getErrorMessage = (showMediaError: string) => {
    switch (showMediaError) {
      case 'imageType': {
        return 'File types accepted: png, jpg, jpeg'
      }
      case 'videoType': {
        return 'File types accepted: mp4, mov'
      }
      case 'imageLimit': {
        return 'Upload limit for an image is 2MB'
      }
      case 'videoLimit': {
        return 'Upload limit for a video is 25MB'
      }
      case 'maxNumImages': {
        return 'Maximum 4 images can be uploaded'
      }
      case 'numVideo': {
        return 'One video can be uploaded per post'
      }
    }
  }

  const clearPost = () => {
    setImageUploaded(false)
    setVideoUploaded(false)
    setPostTitle('')
    setPostDescription('')
    setPostImages([])
    setPostVideo([])
    setPreviewImage([])
    setShowMediaError(null)
    if (createPostPage) history.goBack()
  }

  useEffect(() => {
    setState(location?.state as any)
    setPostToEdit(getState?.data as any)
  }, [getState])
  
  return {
    theme,
    isDevice,
    getProcessedFile,
    maxTitleLength,
    maxDescriptionLength,
    maxVideoFileSize,
    maxImageFileSize,
    cursorPos,
    setCursorPos,
    cursorEl,
    setCursorEl,
    postDescription,
    setPostDescription,
    postTitle,
    setPostTitle,
    previewImage,
    setPreviewImage,
    postImages,
    setPostImages,
    previewVideo,
    setPreviewVideo,
    postVideo,
    setPostVideo,
    showMediaError,
    setShowMediaError,
    imageUploaded,
    setImageUploaded,
    videoUploaded,
    setVideoUploaded,
    newUploads,
    setNewUploads,
    logEventAnalytics,
    media,
    previewMedia,
    post,
    mediaCategory,
    getPostDetails,
    isImage,
    isVideo,
    clearPost,
    getErrorMessage,
    backendUser,
    edit,
    setShowEdit,
    createContent,
    posts,
    setPosts,
    myPosts,
    setMyPosts,
    postToEdit,
    setPostToEdit,
    postEdited,
    notify,
    picturesChanged,
    editContent,
    editSharedPost,
    showReadOnly,
    setReadOnly,
    getState,
    postId,
    setPostId,
    history, 
    backendPartner,
    backendUserFunctions
  } as const
}
